module.exports = __webpack_public_path__ + "img/367-63cb08.png";